//--------------------------------------------------------------------//
//******************** agentsCtrl ************************************//
//--------------------------------------------------------------------//
// Controller for the Agents settings tab. Fetches the agents list
// on load and provides a dialog for creating new agents with
// name and API key.
import addAgentDialogTemplateUrl from './add-agent-dialog.template.html';

angular.module('userSettingsMod')

.controller('agentsCtrl', ['$scope', 'GhDialog', 'AgentsService', 'localizationService', '$templateCache', async function($scope, GhDialog, AgentsService, localizationService, $templateCache) {
  const dictionary = localizationService.getDictionary('account_settings');
  $scope.translate = (word) => localizationService.translate(word, dictionary);

  $scope.agents = [];

  // Fetches all agents from the server and populates the list.
  $scope.getAgents = async function() {
    try {
      $scope.agents = await AgentsService.getList();
      $scope.$evalAsync();
    } catch (error) {
      console.log(error);
    }
  };

  // Opens the "Add Agent" dialog with name and API key inputs.
  $scope.showDialog = function() {
    GhDialog.show({
      position: 'center',
      toolbar: false,
      locals: {
        agents: $scope.agents,
        safeApply: () => $scope.$evalAsync()
      },
      template: {
        toolbar: '',
        resizable: false,
        content: $templateCache.get(addAgentDialogTemplateUrl)
      },
      controller: ['$scope', 'agents', 'safeApply', 'AgentsService', 'localizationService', function($scope, agents, safeApply, AgentsService, localizationService) {
        const dictionary = localizationService.getDictionary('account_settings');
        $scope.translate = (word) => localizationService.translate(word, dictionary);
        $scope.errMessage = '';

        $scope.agent = {
          name: '',
          api_key: '',
          avatar: null
        };
        $scope.avatarFieldModel = {
          image_size: 512,
          avatar_size: 180,
          uploadEvents: true
        };
        $scope.isCreating = false;

        $scope.addAgent = async function() {
          if (!$scope.agent.name || !$scope.agent.name.trim()) {
            $scope.errMessage = 'Please, type agent name';
            return;
          }

          if (!$scope.agent.api_key || !$scope.agent.api_key.trim()) {
            $scope.errMessage = 'Please, enter API key';
            return;
          }

          $scope.isCreating = true;

          try {
            const created = await AgentsService.create({
              name: $scope.agent.name,
              api_key: $scope.agent.api_key,
              gudhub_user_avatar: $scope.agent.avatar
            });
            agents.push(created);
            safeApply();
            $scope.cancel();
          } catch (error) {
            console.log(error);
            $scope.errMessage = error.message || 'Something went wrong. Please, try again';
            $scope.isCreating = false;
            $scope.$evalAsync();
          }
        };
      }]
    });
  };

  await $scope.getAgents();

}]);
